import React from "react";
import classNames from "classnames/bind";
import styles from "./styles.module.scss";
import { DIETS, MEAL_NAME, WEEKDAYS } from "./format";
import { TGrid } from "./types";

const cn = classNames.bind(styles);

interface INeedsGrid {
  /** "shared" or a meal key; used for labels and test ids */
  scope: string;
  grid: TGrid;
  onChange: (weekday: string, need: string, value: number) => void;
}

const parse = (raw: string) => {
  const n = parseInt(raw, 10);
  return isNaN(n) || n < 0 ? 0 : Math.min(n, 999);
};

const NeedsGrid: React.FC<INeedsGrid> = ({ scope, grid, onChange }) => {
  const prefix = scope === "shared" ? "" : `${MEAL_NAME[scope]}: `;
  const count = (day: string, need: string) =>
    (grid[day] && grid[day][need]) || 0;

  return (
    <div className={cn("wrap")}>
      <table className={cn("grid")}>
        <thead>
          <tr>
            <th>Children who need&hellip;</th>
            {WEEKDAYS.map(([d, label]) => (
              <th key={d}>{label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {DIETS.map(([need, label]) => (
            <tr key={need}>
              <td className={cn("diet")}>{label}</td>
              {WEEKDAYS.map(([d, dayLabel]) => (
                <td key={d}>
                  <input
                    className={cn("num", { num_zero: !count(d, need) })}
                    type="number"
                    min={0}
                    max={999}
                    inputMode="numeric"
                    value={count(d, need)}
                    aria-label={`${prefix}${label}, ${dayLabel}`}
                    onChange={(e) => onChange(d, need, parse(e.target.value))}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr>
            <td>Total meals</td>
            {WEEKDAYS.map(([d]) => (
              <td key={d} data-testid={`total-${scope}-${d}`}>
                {DIETS.reduce((sum, [need]) => sum + count(d, need), 0)}
              </td>
            ))}
          </tr>
        </tfoot>
      </table>
    </div>
  );
};

export default NeedsGrid;
